import { Endpoint } from '@philips-emr/hpms-provider-commons/lib/constants';
import { Value } from '@philips-emr/tws-core';
import { HistoryService, HttpService, MessageService, SessionStorageService } from '@philips-emr/tws-core/lib/services';
import { RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';
import { applicationModuleRegistry, isApplicationModule } from '@philips-emr/tws-foundation';

import { Route } from '../route/route';

export default class Audit {
  addRouteListener(): Function {
    return HistoryService.addListener((path: string) => this.routeChangeLog(path));
  }

  routeChangeLog(path: string): Promise<RequestResponse | void> {
    if (path.endsWith('/')) {
      path = path.slice(0, -1);
    }

    const routes: { [route: string]: string } = {
      [this.parseRoute(Route.MY_DATA)]: MessageService.translate('provider.my-data'),
      [this.parseRoute(Route.PRIVACY)]: MessageService.translate('provider.my-data'),
      [this.parseRoute(Route.CALLS)]: MessageService.translate('provider.calls'),
      [this.parseRoute(Route.CALL)]: MessageService.translate('provider.calls'),
      [this.parseRoute(Route.CALL_DETAIL)]: MessageService.translate('provider.calls'),
      [this.parseRoute(Route.NEW_CALL)]: MessageService.translate('provider.calls'),
      [this.parseRoute(Route.CALL_CATEGORY)]: MessageService.translate('provider.calls'),
      [this.parseRoute(Route.DOCUMENTS)]: MessageService.translate('provider.documents'),
      [this.parseRoute(Route.NEGOTIATION)]: MessageService.translate('provider.negotiations'),
      [this.parseRoute(Route.NEGOTIATION_DETAILS)]: MessageService.translate('provider.negotiations'),
      [this.parseRoute(Route.NEGOTIATION_PROPOSAL)]: MessageService.translate('provider.negotiations'),
      [this.parseRoute(Route.TECHNICAL_VISIT)]: MessageService.translate('provider.technical-visit'),
      [this.parseRoute(Route.TECHNICAL_VISIT_DETAILS)]: MessageService.translate('provider.technical-visit'),
      [this.parseRoute(Route.FORM_TECHNICAL_VISIT)]: MessageService.translate('provider.technical-visit'),
      [this.parseRoute(Route.TECHNICAL_VISIT_APPOINTMENTS)]: MessageService.translate('provider.technical-visit'),
      [this.parseRoute(Route.TECHNICAL_VISIT_FORMS)]: MessageService.translate('provider.technical-visit'),
      [this.parseRoute(Route.TECHNICAL_VISIT_INCONSISTENCIES)]: MessageService.translate('provider.technical-visit'),
    };

    applicationModuleRegistry.getAll().forEach(module => {
      if (isApplicationModule(module)) {
        routes[this.parseRoute(module.route)] = MessageService.translate(module.name);
      }
    });

    const functionName = routes[this.parseCurrentRoute(path)];

    if (!functionName) {
      return Promise.resolve();
    }

    const body = {
      path,
      current: functionName,
    };

    return Audit.logAuditFunction(body);
  }

  private static logAuditFunction(body: Record<string, Value>): Promise<RequestResponse> {
    const nrSeqProvider = SessionStorageService.getItem('nrSeqProvider');
    body = { ...body, nrSeqProvider };
    return HttpService.post(Endpoint.POST.AUDIT_FUNCTION, {}, { body });
  }

  private parseCurrentRoute(route: string): string {
    const regex = /\d+/g;
    return route.replace(regex, '');
  }

  private parseRoute(route: string): string {
    const regex = /:\w+/g;
    return route.replace(regex, '');
  }
}
